module.exports = __webpack_public_path__ + "static/img/pc_banner.9f7b462.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pc_banner.png
// module id = MTEA
// module chunks = 1